// composables/useSmoothScroll.ts
export const scrollTo = (id: string) => {
  const element = document.getElementById(id)
  if (element) {
    const rect = element.getBoundingClientRect()
    const top = rect.top + window.scrollY - 70
    window.scrollTo({ top, behavior: 'smooth' })
  }
}
